import React from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import Switches from '../../../../../components/fields/Switches/Switches';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../../configs';
import { dateFormatter, infoFormatterIntl } from '../../../../../utils/formatters';
import FileView from '../../../../../components/fields/FileInput/FileView';

export default function DriverLicenseView(props) {
  const {
    fieldsValidation = {},
    procedure,
    applicantType,
    currentApplication = {},
  } = props;

  const application_carrier_new = currentApplication?.application_carrier_new || {};
  const files = currentApplication?.files || [];
  const registry_subject = currentApplication?.registry_subject || {};

  const {
    driver_license_series,
    driver_license_number,
    driver_license_issue_date,
    driver_license_expiration_date,
  } = application_carrier_new;

  const {
    driver_license_series: oldDriverLicenseSeries,
    driver_license_number: oldDriverLicenseNumber,
  } = registry_subject;

  const driver_license_files = files.filter(item => item.collection_name === 'driver_license_files');

  const hasDriverLicenseData = !!(
    driver_license_series
      || driver_license_number
      || driver_license_issue_date
      || driver_license_expiration_date
  ) || driver_license_series === null
    || driver_license_number === null
    || driver_license_issue_date === null
    || driver_license_expiration_date === null;

  if (![PROCEDURE_TYPE.PROCEDURE_1227_5].includes(procedure) || applicantType !== USER_TYPE.PRIVATE_PERSON) {
    return null;
  }

  return (
    <>
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: hasDriverLicenseData,
            }}
            label="Изменилось водительское удостоверение"
          />
        </Col>
      </Row>
      {hasDriverLicenseData && (
        <>
          <Row className="row-cols-1">
            {infoFormatterIntl(
              'old.driver_license',
              !oldDriverLicenseSeries && !oldDriverLicenseNumber ? null : `${oldDriverLicenseSeries || ''} ${oldDriverLicenseNumber || ''}`,
              fieldsValidation,
              'driver_license',
            )}
          </Row>
          <Row className="row-cols-2">
            {infoFormatterIntl(
              'new.driver_license_series',
              driver_license_series,
              fieldsValidation,
              'application_carrier_new.driver_license_series',
            )}
            {infoFormatterIntl(
              'new.driver_license_number',
              driver_license_number,
              fieldsValidation,
              'application_carrier_new.driver_license_number',
            )}
          </Row>
          <Row className="row-cols-2">
            {infoFormatterIntl(
              'new.driver_license_issue_date',
              dateFormatter(driver_license_issue_date),
              fieldsValidation,
              'application_carrier_new.driver_license_issue_date',
            )}
            {infoFormatterIntl(
              'new.driver_license_expiration_date',
              dateFormatter(driver_license_expiration_date),
              fieldsValidation,
              'application_carrier_new.driver_license_expiration_date',
            )}
          </Row>
          <Row className="row-cols-1">
            {infoFormatterIntl(
              'media.driver_license_files',
              driver_license_files.length ? (
                <FileView
                  readOnly
                  withoutMime
                  withoutHr
                  files={driver_license_files}
                />
              ) : null,
              fieldsValidation,
              '',
              6,
            )}
          </Row>
        </>
      )}
      <div className="hr-row mt-3" />
    </>
  );
}
